export default __webpack_public_path__ + "static/media/ic_cost_amp.81dc0aaf.svg";